import { createFeatureSelector, createSelector } from "@ngrx/store";

import { LoadingState, getError } from "@core/models";

import { Category, ProductContainer } from '@shared/models';

import {
  productContainersAdapter,
  ProductContainersState
} from "./product-containers.state";




const selectFeature = createFeatureSelector<ProductContainersState>('productContainers');

const {
  selectAll,
  selectTotal,
} = productContainersAdapter.getSelectors(selectFeature);

const selectCallState = createSelector(selectFeature, (state) => state.callState);
const selectIsLoading = createSelector(selectFeature, (state) => { return state.callState === LoadingState.LOADING });
const selectIsLoaded = createSelector(selectFeature, (state) => { return state.callState === LoadingState.LOADED });
const selectError = createSelector(selectCallState, (callState) => getError(callState));

const selectActiveProducts = createSelector(
  selectAll,
  (productContainers) => {
    return productContainers.filter(x => x.isActive)
  });

const selectProductContainersByProduct = (productCode: string) => createSelector(
  selectActiveProducts,
  (productContainers) => {
    return productContainers.filter(x => x.productCode == productCode);
  });

const selectProductContainersGroupedByCategory = createSelector(
  selectActiveProducts,
  (productContainers) => {
    let categoryItems: Array<Category<ProductContainer>> = [];
    const categories = [...new Set(productContainers.map((x: ProductContainer) => x.productCategory))];

    categories.forEach((category: string | null, index: number) => {
      const c = new Category(
        category ?? 'None',
        [...new Set(productContainers.filter((x: ProductContainer) => x.productCategory == category))]);
      categoryItems.push(c);
    });

    return categoryItems;
  });


export const ProductContainersSelectors = {
  callState: selectCallState,
  all: selectAll,
  total: selectTotal,
  allActive: selectActiveProducts,
  isLoading: selectIsLoading,
  isLoaded: selectIsLoaded,
  error: selectError,
  productContainersByProduct: (producCode: string) => selectProductContainersByProduct(producCode),
  productContainersGroupedByCategory: selectProductContainersGroupedByCategory,
}
